import React, { useState } from "react";
import { motion } from "framer-motion";
import { FiMail, FiPhone, FiMapPin } from "react-icons/fi";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Thank you for contacting us! We'll get back to you soon.");
    setFormData({ name: "", email: "", subject: "", message: "" });
  };

  return (
    <div className="bg-gray-50 min-h-screen">
      {/* HEADER */}
      <div className="relative w-full h-[60vh] flex items-center justify-center">
        <img
          src="/images/header.jpg"
          alt="Contact Header"
          className="absolute top-0 left-0 w-full h-full object-cover"
        />
        <div className="absolute top-0 left-0 w-full h-full bg-black/50"></div>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="relative z-10 text-center px-4"
        >
          <h1 className="text-4xl md:text-6xl font-bold text-white drop-shadow-lg">
            Contact Us
          </h1>
          <p className="text-gray-200 mt-4 text-lg md:text-xl max-w-2xl mx-auto">
            We'd love to hear from you. Get in touch with us today.
          </p>
        </motion.div>
      </div>

      {/* CONTACT FORM + DETAILS */}
      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-2 gap-12">
        {/* CONTACT FORM */}
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="bg-white shadow-lg rounded-xl p-8"
        >
          <h2 className="text-2xl font-semibold mb-6 text-gray-800">
            Send Us a Message
          </h2>
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-gray-600">Full Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter your name"
                required
                className="w-full mt-1 p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div>
              <label className="block text-gray-600">Email Address</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email"
                required
                className="w-full mt-1 p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div>
              <label className="block text-gray-600">Subject</label>
              <input
                type="text"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                placeholder="Enter subject"
                required
                className="w-full mt-1 p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div>
              <label className="block text-gray-600">Message</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Write your message..."
                rows="5"
                required
                className="w-full mt-1 p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              ></textarea>
            </div>

            <button
              type="submit"
              className="w-full bg-blue-600 hover:bg-blue-700 transition text-white p-3 rounded-lg text-lg font-medium shadow-md"
            >
              Send Message
            </button>
          </form>
        </motion.div>

        {/* CONTACT DETAILS */}
        <motion.div
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="flex flex-col justify-center space-y-6"
        >
          <div className="flex items-center gap-4">
            <FiMapPin className="text-blue-600 text-3xl" />
            <div>
              <h3 className="text-lg font-semibold">Our Offices</h3>
              <p className="text-gray-600">Kwabenya, East Airport, East Legon, Accra, Ghana</p>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <FiPhone className="text-blue-600 text-3xl" />
            <div>
              <h3 className="text-lg font-semibold">Phone Number</h3>
              <p className="text-gray-600">+233 531 100 075 / 053 110 0076</p>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <FiMail className="text-blue-600 text-3xl" />
            <div>
              <h3 className="text-lg font-semibold">Email Address</h3>
              <p className="text-gray-600">info@solonetproperties.com</p>
            </div>
          </div>
        </motion.div>
      </div>

      {/* MAP SECTION */}
      <div className="w-full h-[400px]">
        <iframe
          title="Google Map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3969.9913874343583!2d-0.23979172525374015!3d5.714376494267587!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xfdf9fbc2bd57d49%3A0xe0c3ad2a5a322b0f!2sSolonet%20Properties!5e0!3m2!1sen!2sgh!4v1760100751854!5m2!1sen!2sgh" 
          width="100%"
          height="100%"
          allowFullScreen
          loading="lazy"
          className="border-none"
        ></iframe>
      </div>
    </div>
  );
};

export default Contact;
